export default __webpack_public_path__ + "static/media/Canvas Pack.3235a749.jpg";